import { Injectable } from '@angular/core';
import { TaggingTool } from './tagging-tool.enum';
import { CanvasToolMenu } from '../../components/workspace/partials/canvas-tool-menu/index';
import { EventName, Events } from '../../utils/events';
import { RegionOfInterestProvider } from './region-of-interest';
import { CanvasProvider } from './canvas';
import { DatasetProvider } from '../dataset';

@Injectable()
export class ActiveToolProvider {
    private activeTool: TaggingTool | null = null;
    private latestDrawTool: TaggingTool;
    private previousActiveTool: TaggingTool | null = null;
    private toolMenu: CanvasToolMenu | null = null;

    constructor(
        private events: Events,
        private roiProvider: RegionOfInterestProvider,
        private datasetProvider: DatasetProvider,
        private canvasProvider: CanvasProvider
    ) {
        // TODO: refactor this when history management will be moved out of canvas provider
        this.events.subscribe(EventName.CanvasPolygonRemoved, this.onCanvasPolygonRemoved);
    }

    private onCanvasPolygonRemoved = () => {
        this.activatePenToolAfterSubtraction();
    };

    public async setActiveTool(tool: TaggingTool | null): Promise<void> {
        if (tool === this.activeTool) {
            return;
        }

        if (this.activeTool !== null && Number.isInteger(this.activeTool)) {
            this.previousActiveTool = this.activeTool;
        }

        if (
            tool == TaggingTool.Brush ||
            tool == TaggingTool.Pen ||
            tool == TaggingTool.Addition ||
            tool == TaggingTool.Subtraction
        ) {
            this.latestDrawTool = tool;
        }

        if (this.activeTool === TaggingTool.RegionOfInterest && this.canvasProvider.hasUnsavedChangesInROI) {
            await this.roiProvider.confirmUnsavedChangesAndRetrain(this.datasetProvider.getCurrentDatasetIdentifier());
        }

        if (this.toolMenu && tool) {
            this.toolMenu.show({ taggingTool: tool });
        }

        this.activeTool = tool;
    }

    public activatePenToolAfterSubtraction(): void {
        if (this.getActiveTool() === TaggingTool.Subtraction && !this.canvasProvider.canSubtractPolygons()) {
            this.setActiveTool(TaggingTool.Pen);
        }
        if (this.latestDrawTool === TaggingTool.Subtraction && !this.canvasProvider.canSubtractPolygons()) {
            this.latestDrawTool = TaggingTool.Pen;
        }
    }

    public getActiveTool(): TaggingTool | null {
        return this.activeTool;
    }

    public getPreviousActiveTool(): TaggingTool | null {
        return this.previousActiveTool;
    }

    public rollbackToPreviousActiveTool(): void {
        this.setActiveTool(this.getPreviousActiveTool());
    }

    public useActiveDrawTool(): void {
        this.setActiveTool(this.getActiveDrawTool());
    }

    public getActiveDrawTool(): TaggingTool {
        if (
            this.activeTool == TaggingTool.Brush ||
            this.activeTool == TaggingTool.Pen ||
            this.activeTool == TaggingTool.Addition ||
            this.activeTool == TaggingTool.Subtraction ||
            this.activeTool == TaggingTool.BoundingBox
        ) {
            return this.activeTool;
        } else if (this.latestDrawTool) {
            return this.latestDrawTool;
        } else {
            return TaggingTool.Pen;
        }
    }

    public linkToolMenu(toolMenu: CanvasToolMenu): void {
        this.toolMenu = toolMenu;
    }

    public lock(): void {
        if (this.activeTool) {
            this.setActiveTool(null);
        }
    }

    public unlock(): void {
        if (this.previousActiveTool && !this.activeTool) {
            this.setActiveTool(this.previousActiveTool);
        }
    }

    public clearPreviousActiveTool(): void {
        if (this.previousActiveTool) {
            this.previousActiveTool = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/workspace/active-tool.ts